import { css } from '@emotion/react';

export const root = css`
  display: flex;
  justify-content: center;
  position: fixed;
  inset: auto 0 4.6rem;
  z-index: var(--zindex-toast);
`;
